import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes('upload-image')) {
      let headers;
      headers = {
        setHeaders: {
          'Content-Type': 'application/json;charset=UTF-8',
          // tslint:disable-next-line: max-line-length
          Authorization: `eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJXYWx0ZXIgSmFyZGltIiwiYXVkaWVuY2UiOiJ3ZWIiLCJjcmVhdGVkIjoxNTIxMTQ5MTQ3NTU1LCJleHAiOjE4NjE4NDQ0MDAsImVtYWlsIjoicG9ydGFsQGNlcnMuY29tLmJyIiwiU1RVREVOVF9JRCI6MzE4OTM1fQ.sqLUKH2jYe_6zGZ9Yx_7maEGYalvs7F7J9UJZzuJjzkNjbRXzzGqxpS6VreXJDnfe-YDoriW_DrFOwed0cp8LQ`
        }
      };


      if (false) {

        delete headers.setHeaders['Content-Type'];

      } else if (req.params.has('remove_auth')) {

        delete headers.setHeaders.Authorization;

      }

      req = req.clone(headers);
    }
    return next.handle(req);
  }
}
